import { SubHeaderState } from "components/Layout/Subheader/useSubHeaderStore";
import { create } from "zustand";

const useProductDetailPageStore = create<SubHeaderState>((set) => ({
  showSubheader: true,
  setShowSubheader: (value) => set(() => ({ showSubheader: value }))
}));

export default useProductDetailPageStore;
